var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowdownDash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64587 5.04308C7.69232 5.08964 7.74749 5.12658 7.80824 5.15179C7.86898 5.17699 7.9341 5.18997 7.99987 5.18997C8.06564 5.18997 8.13076 5.17699 8.19151 5.15179C8.25225 5.12658 8.30743 5.08964 8.35387 5.04308L12.9389 0.457083C13.2201 0.175689 13.6017 0.0175504 13.9995 0.017457C14.3974 0.0173626 14.779 0.175322 15.0604 0.456583C15.3418 0.737844 15.4999 1.11937 15.5 1.51723C15.5001 1.91508 15.3421 2.29669 15.0609 2.57808L10.4749 7.16407C9.81784 7.8193 8.92779 8.18726 7.99987 8.18726C7.07196 8.18726 6.18191 7.8193 5.52487 7.16407L0.93887 2.57808C0.657608 2.29669 0.49965 1.91508 0.499744 1.51723C0.499837 1.11937 0.657977 0.737844 0.939372 0.456583C1.22077 0.175321 1.60237 0.0173624 2.00022 0.0174568C2.39808 0.0175503 2.77961 0.175689 3.06087 0.457083L7.64587 5.04308Z",
    fill: "#9D9D9D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowdownDash);
export default __webpack_public_path__ + "static/media/icon-arrowdown-dash.e9589e7d5e05ae77ab573ca99e3b2600.svg";
export { ForwardRef as ReactComponent };